module.exports = "<delhivery-login (onLogin)=\"onLogin($event)\"></delhivery-login>"